"use client";

import type { TodayProjection, TodayRestart } from "@/lib/api/projection-types";

export type PendingRestartCandidate = {
  id: string;
  title: string;
  status: string;
  estimated_minutes?: number;
};

function buildFallbackRestart(task: PendingRestartCandidate): TodayRestart {
  return {
    id: task.id,
    title: task.title,
    why_now: "This is the one open task still waiting for you today.",
    effort_minutes: task.estimated_minutes ?? null,
    confidence: "medium",
    goal: null,
  };
}

export function applyFreshTodayRestartFallback(
  projection: TodayProjection,
  pendingTasks: PendingRestartCandidate[]
): TodayProjection {
  if (projection.restart) return projection;
  if ((projection.queue_peek?.length ?? 0) > 0) return projection;

  const eligibleTasks = pendingTasks.filter((task) => task.status === "pending");
  if (eligibleTasks.length !== 1) return projection;

  return {
    ...projection,
    restart: buildFallbackRestart(eligibleTasks[0]),
  };
}
